export const REENGAGEMENT_STATUS = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Deployed: 'Deployed',
  Inprogress: 'In Progress',
  Failed: 'Failed'
}

export const splitOptions = [
  { value: 'EQUAL', label: 'Split Equally' },
  { value: 'MANUAL', label: 'Split Manually' }
]

export const maxReengagementGroupsAllowed = 5



// WEBPACK FOOTER //
// ./src/components/reengagement-manager/constant.js